import { Avatar, Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import moment from "moment";

import React, {useState, useEffect} from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { listConversation } from "../Application/listConversation.logic";
import { setSelectedChat } from "../Infrastructure/Chat.reducer";

import { GetPhotoProfile } from "../../User/Infrastructure/User.presenter";

const nameStyles = {
  maxWidth: {xs: "190px", lg: "none"},
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
}

const useStyles = makeStyles({
  container: {
    borderRadius: "8px",
    margin: "1em 0em 0em 0em",
    padding: "0.75em",
    "&:hover": { background: "#e8e5e5", cursor: "pointer" },
    "&:focus": { background: "#e8e5e5", cursor: "pointer" },
  },
  selected: { background: "#e8e5e5", cursor: "pointer"},
});
export default function Contact({ contact = {}, isSelected }) {
  const { container, selected } = useStyles();
  const [photo, setPhoto] = useState({});
  const dispatch = useDispatch();
  const history = useHistory();
  const { name, last_name, id, url_photoProfile, createdAt } = contact;

  useEffect(() => {
    if (url_photoProfile) {
      getUrlPhoto(url_photoProfile)
    }
  }, [url_photoProfile]);

  const getUrlPhoto = async (urlPhoto) =>{
    const res = await GetPhotoProfile(urlPhoto);
    setPhoto(res);
  }

  return (
    <Box
      key={`contact-${id}`}
      className={[container, isSelected ? selected : null]}
      onClick={() => {
        listConversation(id);
        dispatch(setSelectedChat(contact));
        history.push(`/chat/${id}`);
      }}
    >
      <Grid container sx={{ margin: 0}} justifyContent="space-between" alignItems="center">
        <Grid item sm={3} md={3}>
          <Avatar alt={`${name} ${last_name} profile`} src={photo} />
        </Grid>
        <Grid item sm={6} md={5}>
          <Box display="flex" flexDirection="column">
            <Typography sx={nameStyles}>
              {name} {last_name}
            </Typography>
          </Box>
        </Grid>
        <Grid item sm={3} md={4}>
          <Typography textAlign="end">
            {moment(createdAt).format("HH:mm")}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
